export const FALLBACK_URL = {
  components: [],
  url: 'https://huddle.com.au'
};

export const telstra_landing = {
  components: [
    {
      type: 'product-hero-banner',
      settings: {
        capsule: 'Exclusive to Telstra Plus members',
        heading: 'Telstra Plus bonus points with Huddle',
        content: `
          <ul class="margin-none">
            <li class="margin-bottom-xxsmall">500 points with your first car or home quote<sup>1</sup></li>
            <li class="margin-bottom-xxsmall">Up to 40,000 Telstra Plus bonus points on each new eligible Huddle car and home insurance policy<sup>1</sup></li>
            <li>5,000 Telstra Plus bonus points on each new travel insurance policy<sup>1</sup></li>
          </ul>
        `,
        image: 'https://media.beopen.com/huddle/huddle-landing-hero.webp',
        brandIcon: 'https://media.beopen.com/telstra/logo-telstra-white.svg',
        buttons: [
          {
            link: 'cmp-hdl-travel',
            label: 'Travel insurance'
          },
          {
            link: 'cmp-hdl-car',
            label: 'Car insurance'
          },
          {
            link: 'hud-compare-home',
            label: 'Home insurance'
          }
        ]
      },
      showTrustpilot: true
    },
    {
      type: 'product-card',
      layout: 'image',
      settings: {
        theme: 'dark',
        columns: 3,
        heading: 'Earn up to 85,500 Telstra Plus points',
        subtext: '<span class="text-white">See the Commonly Asked Questions below, and read the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a>.</span>',
        cards: [
          {
            image: '<img src="https://media.beopen.com/huddle/icon-points-500.png" class="width-full">',
            title: '1st quote',
            content: 'Simply complete your first Huddle car or home quote'
          },
          {
            image: '<img src="https://media.beopen.com/huddle/icon-points-5000.png" class="width-full">',
            title: 'Travel insurance',
            content: 'Purchase a Huddle travel policy for your upcoming trip'
          },
          {
            image: '<img src="https://media.beopen.com/huddle/icon-points-40000.png" class="width-full">',
            title: 'Car insurance',
            content: 'Purchase a Huddle comprehensive car policy'
          },
          {
            image: '<img src="https://media.beopen.com/huddle/icon-points-40000.png" class="width-full">',
            title: 'Home & contents insurance',
            content: 'Purchase a Huddle combined home & contents policy'
          }
        ]
      }
    },
    {
      type: 'product-trustpilot',
      settings: {
        heading: 'Trusted by thousands of Australians',
        reviews: [
          {
            rating: 5,
            title: 'Treated wonderfully',
            content: '"Had to phone to make a claim and was greeted and treated wonderfully. Thank you to Lewis :)"',
            author: 'Melanie F'
          },
          {
            rating: 5,
            title: 'Quick quotes and sign up',
            content: '"Huddle made it easy to insure my car with the whole process done on my phone\'s web browser in 15 minutes while I was at the dealership."',
            author: 'Michelle C'
          },
          {
            rating: 5,
            title: 'Very easy',
            content: '"Very easy online process to manage your policies, especially pay as you go mileage. Also very reasonable premium."',
            author: 'Michael K'
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'highlight',
      settings: {
        theme: 'light',
        columns: 4,
        heading: 'Get insurance in a flash. Easy claims. Flexible options.',
        subtext: '',
        brandIcon: 'https://media.beopen.com/telstra/logo-telstra-blue.svg',
        cards: [
          {
            category: 'TRAVEL INSURANCE',
            image: 'https://media.beopen.com/huddle/huddle-travel.svg',
            title: 'Airport lounge access with Smart Flight Delay<sup>2</sup>',
            content: 'If you purchase a Huddle Travel policy you\'ll also earn 5,000 Telstra Plus bonus points<sup>1</sup>.',
            buttons: [
              {
                link: 'cmp-hdl-travel',
                label: 'Get a quote'
              }
            ],
            links: [
              {
                link: '/overview?campaign=telstra_travel',
                label: 'Learn more about Travel Insurance'
              }
            ]
          },
          {
            category: 'CAR INSURANCE',
            image: 'https://media.beopen.com/huddle/huddle-car.svg',
            title: 'Drive less and save up to 30% with Pay as You Drive<sup>3</sup>',
            content: 'If you purchase a Huddle Comprehensive Car policy you\'ll also earn 40,000 Telstra Plus bonus points<sup>1</sup>.',
            buttons: [
              {
                link: 'cmp-hdl-car',
                label: 'Get a quote'
              }
            ],
            links: [
              {
                link: '/overview?campaign=telstra_car',
                label: 'Learn more about Car Insurance'
              }
            ]
          },
          {
            category: 'HOME INSURANCE',
            image: 'https://media.beopen.com/huddle/huddle-home.svg',
            title: 'Up to 10% off new Home & Contents Insurance<sup>4</sup>',
            content: 'If you purchase a Huddle combined Home and Contents policy you\'ll also earn 40,000 Telstra Plus bonus points<sup>1</sup>.',
            buttons: [
              {
                link: 'hud-compare-home',
                label: 'Get a quote'
              }
            ],
            links: [
              {
                link: '/overview?campaign=telstra_home',
                label: 'Learn more about Home & Contents Insurance'
              }
            ]
          }
        ],
        disclaimer: 'Offer subject to eligibility criteria and other terms and conditions. <a href="https://www.telstra.com.au/plus/huddle-terms">Read the offer terms and conditions</a>. <a href="https://www.telstra.com.au/plus/terms-and-conditions">Read the Telstra Plus terms and conditions</a>. '
      }
    },
    {
      type: 'product-features',
      settings: {
        heading: 'Everything you get with Huddle',
        subtext: '',
        cards: [
          {
            icon: 'huddle-housing-management-24x7claimsprocessing',
            content: 'Buy, manage and claim online, anytime'
          },
          {
            icon: 'huddle-housing-marketing-environmental',
            content: 'Complimentary carbon offset with your new Car or Home policy<sup>5</sup>'
          },
          {
            icon: 'huddle-housing-marketing-liablity',
            content: 'Pay monthly, or save by paying annually on Car or Home Insurance'
          },
          {
            icon: 'huddle-housing-marketing-localsupport',
            content: 'Local insurance experts, book online and we\'ll call when it suits you'
          },
          {
            icon: 'huddle-housing-marketing-flexibleaccess',
            content: 'Flex your excess to reduce your premium'
          },
          {
            icon: 'huddle-housing-marketing-optionals',
            content: 'Customisable cover with optional handy extras'
          },
          {
            icon: 'huddle-housing-management-24/7claimsprocessing',
            content: '24/7 emergency assistance'
          },
          {
            icon: 'huddle-housing-management-fastclaims',
            content: 'Fast claims - some car insurance claims get a decision in minutes'
          }
        ]
      }
    },
    {
      type: 'product-accordion',
      settings: {
        heading: 'Commonly asked questions',
        accordionItems: [
          {
            title: 'How many bonus points will I get?',
            content: `<p>The amount of bonus points you’ll get for buying eligible car, home or travel insurance with Huddle depends on your policy. Offer permits multiple eligible policy purchases. A new policy is eligible for this offer only if it is not purchased within 90 days following the end of a previous policy that covered the same risk, such as destination and travel dates.</p>
            <p>Get 500 points with your first online quote for an eligible home or car insurance policy1. A quote is complete upon reaching the payment page with the final, confirmed price. Travel quotes do not qualify for the bonus points promotion.</p>
            <p>Get 5,000 bonus points on the following Huddle policies. This only applies if the policy hasn't been purchased within 90 days of a previous policy ending that covered the same risk, such as the same destination and travel dates:</p>
            Huddle Travel Insurance - International Essentials<br>
            Huddle Travel Insurance - International Standard<br>
            Huddle Travel Insurance - International Comprehensive<br>
            Huddle Travel Insurance - Domestic Comprehensive<br><br>
            
            <p>Get 15,000 bonus points on the following Huddle policies if you stay insured for 30 days:</p>
            Huddle Car Insurance - Third Party Property<br>
            Huddle Home Insurance - Home only<br>
            Huddle Home Insurance - Contents only<br><br>
            
            <p>Get 40,000 bonus points on the following Huddle policies if you stay insured for 30 days:</p>
            Huddle Comprehensive Car Insurance<br>
            Huddle Combined Home & Contents Insurance`
          },
          {
            title: 'When will I get my points?',
            content: `<p>Points earned for your first quote will be added to your points activity within 14 days of getting your quote.</p>
            <p>For policies purchased members become eligible to receive the points 30 days after the policy start date (as notified by Huddle) and the policy must be active at this time. They will then be added to your points activity within an additional 14 days. See your points activity in your Telstra Plus account for the status of your points.</p>`
          },
          {
            title: 'Is the Huddle insurance offer available to Business members?',
            content: `<p>Huddle does not offer business insurance.</p>
            <p>Telstra business members may be able to get bonus points when they buy an eligible new policy for personal use, subject to <a color="primary" href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">eligibility criteria and offer terms and conditions</a>.</p>`
          },
          {
            title: 'Can I get bonus points if I already have a Huddle policy?',
            content: '<p>Telstra Plus bonus points offers are for eligible new policies only. You are not eligible for bonus points on a policy for a car or home that is currently insured or was previously insured with Huddle in the last 90 days (either by you or someone in your household).</p>'
          },
          {
            title: 'How do I get help with my Telstra Plus membership?',
            content: `<p>Message Telstra via the My Telstra app for help with your Telstra Plus membership.<br>
            <a color="primary" href="https://www.telstra.com.au/mytelstra" target="_blank">Get My Telstra app.</a></p>`
          }
        ]
      }
    },
    {
      type: 'product-text-block',
      settings: {
        content: `
        <p class="text-xsmall text-darkGray"><strong>1. Telstra Plus bonus points offer terms</strong><br>
        Offer ends 30 June 2026 unless extended or withdrawn earlier. Sign up with your Telstra ID to get started. Offer subject to eligibility criteria and <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">other terms and conditions</a>. Must start journey from Telstra Plus website. See the Commonly Asked Questions section, and read the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a>.  Offer permits multiple eligible policy purchases. A new policy is eligible for this offer only if it is not purchased within 90 days following the end of a previous policy that covered the same risk, such as destination and travel dates. Points awarded after a car or home policy has been active for 30 days, for a travel policy, points are awarded 30 days after it’s purchased, and it hasn’t been cancelled. They will then be added to your points activity within an additional 14 days.</p>
        <p class="text-xsmall text-darkGray">Policies are subject to terms and conditions, exclusions, and limits (and sub-limits) of the insurance policy. When making decisions about the product, you should always refer to the Product Disclosure Statement.You can also read the relevant <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination (TMD)</a> which explains who Huddle’s insurance products are suitable for. Must start journey from Telstra Plus website. Read the <a href="https://www.telstra.com.au/plus/financialservicesguide" target="_blank">Telstra Financial Services Guide.</a><br><br>
        <strong>2. Smart Flight Delay</strong><br>Smart Flight Delay is only included with our International Comprehensive plan. You'll need to register your flight(s) at least 2 hours before your flight's scheduled departure time. You can register all of the flights on your international trip. If your flight is delayed for more than 60 minutes from its originally scheduled departure time, you'll receive an email with a complimentary voucher for you and up to four guests flying with you. Other terms and conditions apply.<br><br>
        <strong>3. How our Pay As You Drive discount works‍</strong><br>Saving of up to 30% derived from premium comparisons between Huddle unlimited kilometre comprehensive car cover option and Huddle Pay As You Drive comprehensive car cover option. Calculations based on a sample of profiles of existing Huddle car insurance customers who advised they drive under 15,000 km annually. Current as at 9 May 2024. Actual savings are determined by your individual circumstances, including the kilometres selected, excess chosen and other risk factors. Minimum premiums may reduce savings. Kilometres can be increased during the policy period, an additional premium is payable. In the event of an accident and the end odometer reading is exceeded or is below the start odometer reading on your Certificate of Insurance, an additional excess is applied.<br><br>
        <strong>4. How our combined Home & Contents discount works</strong><br>Receive a 10% discount when you purchase a combined Home and Contents policy, which applies for the life of your combined policy. Minimum premiums may reduce savings discount. We reserve the right to withdraw or extend this discount at any time.<br><br>
        <strong>5. Carbon offset‍</strong><br>We’ll pay to help offset your carbon emissions by planting and protecting native forests when you buy a new policy. We do this by partnering with Greenfleet. They plant biodiverse, native forests in Australia and New Zealand, which are legally protected for 100 years. New policies from 29 November 2022. Not applicable to policy renewal.<br><br>
        Our car and home insurance is issued by Huddle Insurance, a business name of Open Insurance Pty Ltd, ABN 23 166 949 444, AFSL no. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL no. 241436. Open acts as an agent of Hollard and not on your behalf. Any information provided on this site is general information only and does not take into account your individual needs, objectives or financial situation. You should carefully read the relevant Product Disclosure Statement and Financial Services Guide, and consider the relevant Target Market Determination to help you decide if the product is right for you. Eligibility criteria apply.<br><br>
        Our travel insurance is arranged, administered and issued by Huddle Insurance on behalf of the insurer, certain underwriters at Lloyd's. Open acts as an agent of the insurer and not on your behalf. Any information is general information only and does not take into account your individual needs, objectives or financial situation. You should carefully read the relevant Combined Financial Services Guide and Product Disclosure Statement, and consider the relevant Target Market Determination to help you decide if the product is right for you. UMR: B1262BW0505224.<br><br>
        Telstra Limited (ABN 64 068 174 781, AR No. 1303090) is an authorised representative of Open Insurance Pty Ltd (ABN 23 166 949 444, AFSL No. 451712) (Open).<br><br>
        Insurance issued by Huddle Insurance, a business name of Open Insurance Pty Ltd ABN 23 166 949, 444 AFSL No. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL No. 241436. Any information or advice provided on this site is general only and doesn't take into account your individual needs, objectives or financial situation. Benefits are subject to terms and conditions, including exclusions and limits of the insurance policy. Please carefully read the relevant Product Disclosure Statement (PDS) and Financial Services Guide and consider the relevant Target Market Determination (TMD) to decide if the product is right for you.
        </p>`
      }
    }
  ]
};

export const telstra_travel = {
  components: [
    {
      type: 'product-hero-banner',
      settings: {
        capsule: 'Exclusive to Telstra Plus members',
        heading: 'Insure your trip & get Telstra Plus points',
        content: 'Telstra Plus members get 5,000 Telstra Plus bonus points on each new travel insurance policy<sup>1</sup>.',
        image: 'https://media.beopen.com/huddle/huddle-travel-hero.webp',
        brandIcon: 'https://media.beopen.com/telstra/logo-telstra-white.svg',
        buttons: [
          {
            link: 'cmp-hdl-travel',
            label: 'Get a quote in minutes'
          }
        ]
      }
    },
    {
      type: 'product-trustpilot',
      settings: {
        heading: 'Join 100k+ Australians with Huddle insurance'
      }
    },
    {
      type: 'product-callout',
      settings: {
        heading: 'Earn up to 5,000 Telstra Plus points',
        content: 'See the Commonly Asked Questions below, and read the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a>.'
      }
    },
    {
      type: 'product-cross-content',
      settings: {
        heading: 'Airport lounge access with Smart Flight Delay',
        content: `Don't let flight delays ruin your trip. Smart Flight Delay is included with our International Comprehensive plan, and gives you access to 1,400+ lounges around the world in just 2 steps:
        <ol>
          <li><strong>Register your flights</strong><br>You need to <a href="https://huddle.smartdelay.com/" color="primary">register</a> your flights at least 2 hours before your flight\'s scheduled departure time. You can register all of the flights on your international trip.<br><br></li>
          <li><strong>We'll monitor your flights</strong><br>If your flight is delayed for more than 60 minutes from its originally scheduled departure time, you\'ll receive an email with a complimentary voucher for you and up to four guests flying with you.<sup>1</sup></li>
        </ol>`,
        image: 'https://media.beopen.com/huddle/huddle-travel-lounge-acces.webp',
        buttons: [
          {
            link: 'cmp-hdl-travel',
            label: 'Get a quote'
          }
        ],
        disclaimer: '<a href="https://huddle.com.au/pds" color="primary" class="small">Terms and conditions apply</a>'
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Earn up to 5,000 Telstra Plus points',
        cards: [
          {
            image: 'huddle-outlined-marketing-optionals',
            title: 'Build the cover that suits you',
            content: 'Choose your level of cover, pick your cover limit for your cancellation expenses or purchase Optional Extras. It\'s how travel insurance should be.'
          },
          {
            image: 'huddle-outlined-management-emergencyassistance',
            title: '24/7 Emergency Assistance',
            content: 'You\'ll have direct access to our 24/7 Emergency Assistance team if you need help while travelling.'
          },
          {
            image: 'huddle-outlined-valuables-personalmedicalequipment',
            title: 'COVID-19 cover if you’re sick overseas',
            content: 'All of our international plans include cover for overseas emergency medical costs if you\'re diagnosed with COVID-19 on your trip. Cover terms apply.'
          }
        ]
      }
    },
    {
      type: 'product-features-table',
      settings: {
        heading: 'Fly away with cover that suits you',
        content: 'Summary only. Full benefits, terms and conditions are in our <a href="https://www.huddleinsurance.com/au/car-insurance" color="primary" target="_blank">Product Disclosure Statement</a>.',
        tableData: [
          {
            tabLabel: 'International',
            footer: `
              <p>2. The cover limit for Cancellation expenses is chosen when you buy your policy and will be listed on your Certificate of Insurance. This limit is the maximum we’ll pay for all claims for this benefit under your policy. The limit is not per adult traveller. Sub-limits apply.</p>
              <p>3. Sub-limits apply.</p>
              <p>4. The term ‘Unlimited’ means that for covered events, there is no capped dollar sum insured. Terms, conditions, exclusions limits and sub-limits apply. Please refer to the Product Disclosure Statement for further details.</p>
              <p>5. There’s no cover under Personal liability and Permanent disability for any claims arising from participation in any of the activities listed under the Adventure Pack, the Motorcycle/Moped Pack or the Snow Pack.</p>
            `,
            table: [
              [
                {},
                {
                  label: 'Essentials'
                },
                {
                  label: 'Standard'
                },
                {
                  label: 'Comprehensive'
                }
              ],
              [
                {
                  label: 'Your health'
                },
                {},
                {},
                {}
              ],
              [
                {
                  label: 'Overseas emergency medical and repatriation'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Hospital cash allowance'
                },
                {
                  label: 'No cover',
                  icon: ''
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Accidental death'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Permanent disability<sup>5</sup>'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Loss of income'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$10,400<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Your trip'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Cancellation expenses'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: 'As selected<sup>9</sup>'
                }
              ],
              [
                {
                  label: 'Additional expenses'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle_outline'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$50,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Travel delay expenses'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$2,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Special event transport expenses'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Your stuff'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Luggage and personal belongings'
                },
                {
                  label: 'No cover',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'No cover',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: '<span class="font-normal">SUB-LIMITS</span>'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Personal computers, laptops, tablets, cameras or video cameras</span>'
                },
                {
                  label: '$500',
                  icon: ''
                },
                {
                  label: '$3,000',
                  icon: ''
                },
                {
                  label: '$3,000',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">Mobile phones, smartphones and smartwatches</span>'
                },
                {
                  label: '$500',
                  icon: ''
                },
                {
                  label: '$1,000',
                  icon: ''
                },
                {
                  label: '$1,000',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">All other items</span>'
                },
                {
                  label: '$500',
                  icon: ''
                },
                {
                  label: '$750',
                  icon: ''
                },
                {
                  label: '$750',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Your liability'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Rental vehicle insurance excess'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$3,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$6,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Personal liability<sup>5</sup>'
                },
                {
                  label: '$1,000,000',
                  icon: 'check_circle_outline'
                },
                {
                  label: '$2,500,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$5,000,000',
                  icon: 'check_circle_outline'
                }
              ]
            ]
          },

          {
            tabLabel: 'Domestic',
            footer: `
              <p>6. The cover limit for Cancellation expenses is chosen when you buy your policy and will be listed on your Certificate of Insurance. This limit is the maximum we\'ll pay for all claims for this benefit under your policy. The limit is not per adult traveller. Sub-limits apply.</p>
              <p>7. Sub-limits apply.</p>
              <p>8. There’s no cover under Personal liability and Permanent disability for any claims arising from the Snow Pack.</p>
            `,
            table: [
              [
                {},
                {
                  label: 'Comprehensive'
                },
                {
                  label: ''
                },
                {
                  label: ''
                }
              ],
              [
                {
                  label: 'Your Trip'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Cancellation expenses'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Additional expenses'
                },
                {
                  label: '$50,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Travel delay expenses'
                },
                {
                  label: '$2,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Your stuff'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Luggage and personal belongings'
                },
                {
                  label: '$10,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">SUB-LIMITS</span>'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Personal computers, laptops, tablets, cameras or video cameras</span>'
                },
                {
                  label: '$3,000',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Mobile phones, smartphones and smartwatches</span>'
                },
                {
                  label: '$1,000',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">All other items</span>'
                },
                {
                  label: '$750',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Delayed luggage and personal belongings'
                },
                {
                  label: '$750',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Your health'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Accidental death'
                },
                {
                  label: '$25,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Permanent disability<sup>8</sup>'
                },
                {
                  label: '$25,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Your liability'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Rental vehicle insurance excess'
                },
                {
                  label: '$6,000',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Personal liability<sup>8</sup>'
                },
                {
                  label: '$5,000,000',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ]
            ]
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Optional Extras',
        subtext: 'Build the cover that suits your trip, with our range of Optional Extras. <br>Summary only. Full benefits, terms and conditions are in our <a href="https://huddle.com.au/pds" target="_blank" color="primary">Product Disclosure Statement</a>.',
        cards: [
          {
            image: 'huddle-outlined-travel-cruise',
            title: 'Cruise Pack',
            content: 'Cover for your overnight or multi-night sea or ocean cruise, plus access to extra cruise-related benefits like ship to shore evacuation and cabin confinement.',
            capsules: [
              {
                label: 'Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-options-sportcover',
            title: 'Snow Pack',
            content: 'Cover for your snow sport activities, plus access to extra snow-related benefits like cover for your own snow sport equipment and piste closure. An additional excess applies.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-values-noexcuses',
            title: 'Adventure Pack',
            content: 'Cover for activities like abseiling, zip-lining, outdoor rock climbing (with ropes and safety gear) and more.Not available with our Domestic plan.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-travel-motorcyclecover',
            title: 'Motorcycle/Moped Pack',
            content: 'Cover for riding a motorcycle or moped overseas (as a rider or passenger) on your trip.Not available with our Domestic plan.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-valuables-electronics',
            title: 'Valuables Pack',
            content: 'Travelling with valuables? You can increase the sub-limits under your plan for your luggage and personal belongings for extra protection.',
            capsules: [
              {
                label: 'Comprehensive',
                theme: 'black'
              }
            ]
          }
        ]
      }
    },
    {
      type: 'product-banner',
      settings: {
        heading: 'Get rewarded with Telstra Plus',
        content: 'Telstra Plus members can get 5,000 Telstra Plus bonus points on each new travel insurance policy.<sup>1</sup>',
        image: 'https://media.beopen.com/huddle/huddle-rewards.webp',
        buttons: [
          {
            link: 'cmp-hdl-travel',
            label: 'Get a quote'
          }
        ]
      }
    },
    {
      type: 'product-accordion',
      settings: {
        heading: 'Commonly asked questions',
        accordionItems: [
          {
            title: 'How many bonus points will I get?',
            content: `
            The amount of bonus points you’ll get for buying eligible car or home insurance with Huddle depends on your policy.<br><br>
            Get 500 points with your first online quote for an eligible home or car insurance policy1. A quote is complete upon reaching the payment page with the final, confirmed price. Travel quotes do not qualify for the bonus points promotion.<br><br>
            Get 5,000 bonus points on the following Huddle policies. This only applies if the policy hasn't been purchased within 90 days of a previous policy ending that covered the same risk, such as the same destination and travel dates:<br>
            Huddle Travel Insurance – International Essentials<br>
            Huddle Travel Insurance – International Standard<br>
            Huddle Travel Insurance – International Comprehensive<br>
            Huddle Travel Insurance – Domestic Comprehensive<br><br>

            Get 15,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
            Huddle Car Insurance – Third Party Property<br>
            Huddle Home Insurance – Home only<br>
            Huddle Home Insurance – Contents only<br><br>

            Get 40,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
            Huddle Comprehensive Car Insurance<br>
            Huddle Combined Home & Contents Insurance
            `
          },
          {
            title: 'Can I purchase a Huddle travel insurance policy if I\'m already travelling?',
            content: `
            No, you won't be eligible to purchase a Huddle travel insurance policy if you're already travelling. You need to purchase a Huddle travel insurance policy before you begin your trip.<br><br>
            Cover terms apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'How do I make changes to my travel insurance policy?',
            content: `
            Need to extend your trip or add a destination to your policy?<br><br> 
            You can apply to make changes to your policy by logging in to your <a href="" color="primary">Huddle account</a>.<br><br>
            Cover terms apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover pre-existing medical conditions?',
            content: `
            We cover the 31 pre-existing medical conditions listed in the table below, as long as you meet the following criteria on the date you purchase your policy:<br>
            <ul> 
              <li>you haven't been hospitalised or needed treatment for any of the listed conditions by any medical adviser in the last 12 months (unless a different time period is listed in below);</li>
              <li>you aren't under investigation for any of the listed conditions;</li>
              <li>you aren't awaiting investigation, surgery, treatment or procedures for any of the listed medical conditions; and</li>
              <li>your condition meets any relevant additional criteria listed in the table below.</li>
            </ul>
            The specified additional criteria (if any) apply, including any stated time periods related to these covered medical conditions listed in the table below, at the time your policy is purchased.<br><br>
            <div class="grid margin-bottom-xmedium">
              <div class="cell cell-large-col-span-4 font-bold">Medical condition</div>
              <div class="cell cell-large-col-span-5 font-bold">Additional criteria</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Acne</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Allergy</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You have no known respiratory conditions e.g. asthma; and</li>
                  <li>You haven’t required treatment by a medical adviser in the last 6 months.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Asthma</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You’re under 60 years of age at the time your policy is issued; and</li>
                  <li>You have no other lung disease.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Bell’s palsy</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Bunions</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Carpal tunnel syndrome</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Cataracts</div>
              <div class="cell cell-large-col-span-5">In the last 90 days, you haven’t had an operation for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Coeliac disease</div>
              <div class="cell cell-large-col-span-5">In the last 6 months, you haven’t been treated by a medical adviser for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Congenital blindness</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Congenital deafness</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Ear grommets</div>
              <div class="cell cell-large-col-span-5">You haven’t had an ear infection in the last 3 months.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Epilepsy</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You haven't required hospitalisation for epilepsy in the last 2 years, including as an outpatient;</li>
                  <li>You haven’t changed your medication regime for epilepsy in the last 12 months; and</li>
                  <li>You don't have an underlying medical condition that causes, contributes to or materially increases the risk of the epilepsy e.g. previous head trauma, brain tumour or stroke.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Gastric reflux</div>
              <div class="cell cell-large-col-span-5">Your gastric reflux doesn’t relate to an underlying diagnosis e.g. hernia or gastric ulcer.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Glaucoma</div>
              <div class="cell cell-large-col-span-5">You have no ongoing complications for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Goitre</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Gout</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Graves’ disease</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hiatus hernia</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hip replacement, knee replacement and shoulder replacement</div>
              <div class="cell cell-large-col-span-5">The procedure was performed more than 6 months ago and less than 10 years ago.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hip resurfacing</div>
              <div class="cell cell-large-col-span-5">You haven’t had any postoperative complications relating to the surgery.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hypercholesterolaemia (high cholesterol)</div>
              <div class="cell cell-large-col-span-5">You don’t have a known heart or cardiovascular condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hypertension (high blood pressure)</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You don’t have a known heart or cardiovascular condition;</li>
                  <li>You don’t have Type 1 diabetes or Type 2 diabetes;</li>
                  <li>In the last 12 months your blood pressure medication hasn’t changed; and</li>
                  <li>You aren’t suffering symptoms of hypertension.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Menopause</div>
              <div class="cell cell-large-col-span-5">You don’t have osteoporosis.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Peptic ulcer/gastric ulcer</div>
              <div class="cell cell-large-col-span-5">In the last 12 months, the peptic/gastric ulcer has been stable.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Plantar fasciitis</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Raynaud’s disease</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Skin cancer</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>Your skin cancer isn’t a melanoma;</li>
                  <li>You haven’t had chemotherapy or radiotherapy for this condition; and</li>
                  <li>Your skin cancer doesn’t require any follow-up treatment.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Trigger finger</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Urinary incontinence</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Underactive thyroid/ overactive thyroid</div>
              <div class="cell cell-large-col-span-5">The cause of your underactive/overactive thyroid wasn’t a tumour.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
            </div>
            If you have a pre-existing medical condition when you purchase your policy that:
            <ul>
              <li>isn't listed in the table above; or</li>
              <li>is listed in the table above, but at the date you purchase the policy, you don't meet the relevant criteria for it to be covered,</li>
            </ul>
            then you won't be covered for any claim that arises from the pre-existing medical condition. <br>
            Terms, conditions, exclusions, limits and sub-limits apply. Please see the relevant PDS for more details.
            `
          },
          {
            title: 'Am I covered if I ride a motorcycle or moped overseas?',
            content: `
              If you're planning on riding a motorcycle or moped overseas on your trip and want cover for participating in those activities, you'll need to purchase the optional Motorcycle/Moped Pack, available on International Comprehensive and Standard Plans only.<br><br>
              Adding the Motorcycle/Moped Pack doesn't add another policy benefit, but it extends cover under your policy to include claims that arise because of participating in riding a motorcycle or moped overseas on your trip, except for cover under Permanent disability and Personal liability.<br><br>
              Cover is provided under this Optional Extra pack only if:
              <ul>
                <li>the motorcycle or moped is motorised and its engine capacity is 250cc or less;</li>
                <li>while in control of the motorcycle or moped, you hold an Australian motorcycle rider’s licence or an Australian motor vehicle driver’s licence valid for that class of motorcycle or moped being ridden, and a licence valid for the country that the motorcycle or moped is being ridden in;</li>
                <li>while you're a passenger, the driver in control of the motorcycle or moped holds a license valid for the country that the motorcycle or moped is being ridden in;</li>
                <li>you're wearing an appropriate safety helmet;</li>
                <li>you're not racing the motorcycle or moped; and</li>
                <li>you're not riding the motorcycle or moped in a professional capacity (for example, as a paid delivery driver).</li>
              </ul>
              If you're participating in riding a motorcycle or moped overseas on your trip and you haven't bought the Motorcyle/Moped Pack, there'll be no cover under the policy for any claims related to this activity.<br><br>
              Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover cruising?',
            content: `
              Going on a river cruise? Cover for river cruises are automatically included under your policy.<br><br>
              However, if you're planning on heading on an overnight or multi-night sea or ocean cruise within Australian territorial waters or while you are overseas, you'll need to purchase the optional Cruise Pack. The optional Cruise Pack is only available on International Comprehensive and Domestic Comprehensive plans.<br><br>
              Buying the Cruise Pack extends the cover under this policy’s benefits for claims arising from your cruise and adds some additional cruise-related benefits such as cover for Emergency medical cover while cruising including ship to shore evacuation cover, Cabin confinement and Missed shore excursions.<br><br>
              If you're going on an overnight or multi-night sea or ocean cruise while you're on your trip and you haven't bought the Cruise Pack, there'll be no cover under the policy for claims related to that cruise.<br><br>
              Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover claims related to COVID-19?',
            content: `
            If you or your travel companion are positively diagnosed as suffering a sickness recognised as an epidemic or pandemic (like COVID-19), and the diagnosis is certified by a medical adviser in writing, you may be able to claim for some benefits which are specified in the PDS. This includes the cancellation or rescheduling of your trip, or your medical expenses incurred overseas during your trip, due to this diagnosis. <br><br>
            Except for this limited cover, cover for epidemics and pandemics are generally excluded under the policy.<br><br>
            This means you will not be covered if you contracted the epidemic or pandemic sickness when you had travelled against an advice or warning by the Australian Government and didn't take appropriate action to avoid contracting the sickness, for example, by delaying travel to the country or part of the country referred to in the travel warning.<br><br>
            Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          }
        ]
      }
    },
    {
      type: 'product-text-block',
      settings: {
        content: `<p class="small text-darkGray">
        <strong>1. Telstra Plus bonus points offer terms</strong><br>
  Offer ends 30 June 2026 unless extended or withdrawn earlier. Sign up with your Telstra ID to get started. Offer subject to eligibility criteria and other terms and conditions. Must start journey from Telstra Plus website. Read the Telstra Plus terms and conditions. Read the offer terms and conditions.  Offer permits multiple eligible policy purchases. A new policy is eligible for this offer only if it is not purchased within 90 days following the end of a previous policy that covered the same risk, such as destination and travel dates. Points awarded after a car or home policy has been active for 30 days, for a travel policy, points are awarded 30 days after it’s purchased, and it hasn’t been cancelled. Policies are subject to terms and conditions, exclusions, and limits (and sub-limits) of the insurance policy. When making decisions about the product, you should always refer to the Product Disclosure Statement.You can also read the relevant Target Market Determination (TMD) which explains who Huddle’s insurance products are suitable for. Must start journey from Telstra Plus website. <a href="">Read the Telstra Financial Services Guide</a>.<br><br>
  Our travel insurance is arranged, administered and issued by Huddle Insurance on behalf of the insurer, certain underwriters at Lloyd's. Open acts as an agent of the insurer and not on your behalf. Any information is general information only and does not take into account your individual needs, objectives or financial situation. You should carefully read the relevant Combined Financial Services Guide and Product Disclosure Statement, and consider the relevant Target Market Determination to help you decide if the product is right for you. UMR: B1262BW0505224.
      </p>
      <p class="small text-darkGray">
      Telstra Limited (ABN 64 068 174 781, AR No. 1303090) is an authorised representative of Open Insurance Pty Ltd (ABN 23 166 949 444, AFSL No. 451712) (Open).
      </p>
      `
      }
    }
  ]
};

export const telstra_car = {
  components: [
    {
      type: 'product-hero-banner',
      settings: {
        capsule: 'Exclusive to Telstra Plus members',
        heading: 'Insure your car & get Telstra Plus points',
        content: 'Telstra Plus members can earn up to 40,500 bonus points with new Huddle Comprehensive Car Insurance<sup>1</sup>.',
        image: 'https://media.beopen.com/huddle/huddle-car-hero.webp',
        brandIcon: 'https://media.beopen.com/telstra/logo-telstra-white.svg',
        buttons: [
          {
            link: 'cmp-hdl-car',
            label: 'Get a quote in minutes'
          }
        ]
      }
    },
    {
      type: 'product-trustpilot',
      settings: {
        heading: 'Trusted by thousands of Australians, 100,000+ policies sold',
        reviews: [
          {
            rating: 5,
            title: 'Treated wonderfully',
            content: '"Had to phone to make a claim and was greeted and treated wonderfully. Thank you to Lewis :)"',
            author: 'Melanie F'
          },
          {
            rating: 5,
            title: 'Quick quotes and sign up',
            content: '"Huddle made it easy to insure my car with the whole process done on my phone\'s web browser in 15 minutes while I was at the dealership."',
            author: 'Michelle C'
          },
          {
            rating: 5,
            title: 'Very easy',
            content: '"Very easy online process to manage your policies, especially pay as you go mileage. Also very reasonable premium."',
            author: 'Michael K'
          }
        ]
      }
    },
    {
      type: 'product-callout',
      settings: {
        heading: 'Earn up to 40,500 Telstra Plus points<sup>1</sup>',
        content: 'See the Commonly Asked Questions below, and read the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a>.'
      }
    },
    {
      type: 'product-cross-content',
      settings: {
        heading: 'Drive less and save up to 30%<sup>2</sup>',
        content: `
        Pay for the distance you need and pocket the savings with Pay As You Drive Cover.<br><br>
        Save up to 30% on your premium if you drive 15,000km or less each year compared to our regular Comprehensive Cover.
        `,
        image: 'https://media.beopen.com/huddle/huddle-PAYD.webp',
        buttons: [
          {
            link: 'cmp-hdl-car',
            label: 'Get a quote'
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Car insurance made easy',
        cards: [
          {
            image: 'huddle-valuables-electronics',
            title: 'Buy, manage and claim online 24/7',
            content: 'You’re in control. It’s how insurance should be.'
          },
          {
            image: 'huddle-outlined-management-fastclaims',
            title: 'Back on your feet, faster',
            content: 'Submit a claim online, anytime and in some cases, you\'ll get a decision in minutes.'
          },
          {
            image: 'huddle-outlined-marketing-localsupport',
            title: 'Local insurance experts',
            content: 'Have questions about your quote, policy or claim? Our friendly Sunshine Coast and Melbourne teams can give you a hand.'
          }
        ]
      }
    },
    {
      type: 'product-features-table',
      settings: {
        heading: 'Drive away with insurance that counts',
        content: 'Summary only. Full benefits, terms and conditions are in our <a href="https://www.huddleinsurance.com/au/car-insurance" color="primary" target="_blank">Product Disclosure Statement</a>.',
        tableData: [
          {
            tabLabel: 'International',
            footer: '',
            table: [
              [
                {},
                {
                  label: `
                    Third party property<br><br>
                    <span class="font-normal">This covers you for damage to other people’s vehicles and property.</span>
                  `
                },
                {
                  label: `Comprehensive<br><br>
                  <span class="font-normal">Covers you for damage to your car, as well as for damage to other people’s vehicles and property.</span>
                  `
                },
                {
                  label: `Huddle Black Comprehensive<br><br>
                  <span class="font-normal">Everything in Comprehensive. Plus much more.</span>
                  `
                }
              ],
              [
                {
                  label: `Theft and damage cover<br>
                  <span class="font-normal">Cover for loss or damage caused by collision, fire, malicious damage, theft, attempted theft and natural events like hail, storm, flood and bushfire.</span>
                  `
                },
                {
                  label: 'Limited cover only, for fire, theft and attempted theft, up to $10,000 if optional Fire and Theft cover is selected',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'check_circle_outline'
                },
                {
                  label: '',
                  icon: 'check_circle_outline'
                }
              ],
              [
                {
                  label: `Pay As You Drive<br>
                  <span class="font-normal">Save up to 30% compared to our regular comprehensive cover if you drive less than 15,000 kms per year.</span>
                  `
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: 'Optional',
                  icon: ''
                },
                {
                  label: 'Optional',
                  icon: ''
                }
              ],
              [
                {
                  label: `New for old car replacement<br>
                  <span class="font-normal">We'll replace your car with a new one if it's written off and you're the first registered owner.</span>
                  `
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: 'Up to 2 years',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to 3 years (and if it’s travelled less than 70,000 kms)',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Essential repairs<br>
                  <span class="font-normal">We’ll pay for essential temporary repairs to restore your car to a roadworthy and safe condition so that you can drive to your intended destination.</span>
                  `
                },
                {
                  label: 'Up to $500 If optional Fire & Theft cover is selected',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $500',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $500',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Emergency travel and accommodation<br>
                  <span class="font-normal">We'll pay for your necessary travel and accommodation if your car is damaged by a covered incident, can't be safely driven and is over a certain number of kms from home.</span>
                  `
                },
                {
                  label: 'Up to $500 If optional Fire & Theft cover is selected (if 200 kms or more away from home)',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $500 If 200 kms or more away from home',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $2,000 If 100 kms or more away from home',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Towing costs<br>
                  <span class="font-normal">We’ll cover the reasonable costs of towing a damaged car to the nearest safe and secure place. We will also cover the reasonable costs of towing your damaged car to an approved repairer.</span>
                  `
                },
                {
                  label: 'Optional<br>If optional Fire & Theft cover is selected and your claim is for fire, theft or attempted theft of your car.',
                  icon: ''
                },
                {
                  label: '',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Personal property cover<br>
                  <span class="font-normal">We'll pay for theft or damage to personal property in the car, that is designed to be worn or carried, such as clothes or bags.</span>
                  `
                },
                {
                  label: 'Up to $500 if optional Fire & Theft cover is selected and your claim if for fire, theft or attempted theft of your car.',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $500',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $1,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Hire car after theft<br>
                  <span class="font-normal">If your car is stolen, we'll either organise the hire of a car or reimburse you the cost of a hire car to get you back on the road.</span>
                  `
                },
                {
                  label: 'Up to $70 per day for up to 14 days if optional Fire & Theft cover is selected',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $70 per day for up to 14 days',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $80 per day for up to 14 days',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Legal liability cover<br>
                  <span class="font-normal">We’ll cover the driver of your car for damage to someone else's vehicle or property, caused by the use of your car.</span>
                  `
                },
                {
                  label: 'Up to $20m',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $20m',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $30m',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Locks and keys<br>
                  <span class="font-normal">If your keys are stolen, we’ll pay to replace or recode your car's locks and keys.</span>
                  `
                },
                {
                  label: 'Up to $1,000 if optional Fire & Theft cover is selected',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $1,000',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $2,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Child safety seats and prams<br>
                  <span class="font-normal">We'll pay up to $500 to help cover the cost of replacing child seats, baby capsules and prams damaged or stolen in an incident involving your car.</span>
                  `
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Rental car excess or bond cover<br>
                  <span class="font-normal">We'll cover up to $2,000 for the excess charged if your rental car is damaged or stolen. Cover terms apply.</span>
                  `
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Choice of repairer<br>
                  <span class="font-normal">You can choose your own repairer or a trusted car repairer we select.</span>
                  `
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'check_circle'
                }
              ]
            ]
          }
        ],
        terms: `
          <p class="text-xsmall">Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination</a> which explains who the products are suitable for.</p>
        `
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Choose your extras',
        subtext: '<p>Customise your Comprehensive Cover with the add-ons that suit you.</p>',
        cards: [
          {
            image: 'huddle-outlined-options-roadassitance',
            title: 'Roadside assistance',
            content: 'Car breakdowns are unpredictable and usually happen at the worst times. That\'s why we offer Roadside Assistance as an optional extra to our car insurance products. With Huddle Black Cover, roadside assistance is included. This service is provided by Allianz Global Assistance. Read the Roadside Assistance T&Cs.',
            capsules: [
              {
                label: 'Included with Huddle Black',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-options-hirecar',
            title: 'Hire car for up to 10 days',
            content: 'We\'ll repair or replace your front windscreen excess-free, once every 12 months.'
          },
          {
            image: 'huddle-outlined-options-kangacover',
            title: 'Kanga Cover',
            content: 'Your first animal collision claim within a 12 month period is excess-free. Huddle gives $4 from every Kanga Cover policy sold to Australian Wildlife Conservancy.'
          },
          {
            image: 'huddle-outlined-options-sportcover',
            title: 'Sports Cover',
            content: 'Up to $3,000 to cover your sports gear while it\'s in or on your car. Cover terms apply.'
          },
          {
            image: 'huddle-outlined-options-excessfreewindscreen',
            title: 'Excess-free windscreen',
            content: 'Your first animal collision claim within a 12 month period is excess-free. Huddle gives $4 from every Kanga Cover policy sold to Australian Wildlife Conservancy.'
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'dark',
        columns: 3,
        type: 'simple-icon',
        heading: 'Huddle Black, our most powerful insurance yet ',
        subtext: '<p class="text-white">Enjoy all the benefits of our Comprehensive cover, plus: </p>',
        cards: [
          {
            image: 'huddle-marketing-liability',
            title: 'Higher cover limits',
            content: 'For personal property, emergency accommodation and travel, locks, keys and more.'
          },
          {
            image: 'huddle-marketing-newforold',
            title: '3 years new for old replacement',
            content: 'Get a bonus year of new for old protection for your new car, if it\'s travelled up to 70,000kms.'
          },
          {
            image: 'huddle-outlined-options-chooserepairer',
            title: 'Choose your repairer',
            content: 'You can pick your own repairer or a trusted car repairer we choose.'
          },
          {
            image: 'huddle-options-hirecar',
            title: 'Hire car after theft',
            content: 'If your car is stolen, we\'ll either organise the hire of a car or reimburse you the cost of a hire car, up to $80 a day for 14 days.'
          },
          {
            image: 'huddle-outlined-options-roadassitance',
            title: '24/7 Roadside Assistance',
            content: 'Enjoy peace of mind with a trusted national support network in Australia and unlimited callouts.<sup>5</sup>'
          },
          {
            image: 'huddle-options-hirecar',
            title: 'Rent a car in AU and we’ll cover the excess',
            content: 'Grabbing a rental car for your holiday? We\'ll cover up to $2,000 for the excess charged if the rental car is damaged or stolen. Cover terms apply.'
          }
        ],
        buttons: [
          {
            link: 'cmp-hdl-car',
            label: 'Get a quote'
          }
        ],
        disclaimer: 'Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination</a> which explains who the products are suitable for.'
      }
    },
    {
      type: 'product-banner',
      settings: {
        heading: 'Get rewarded with Telstra Plus',
        content: 'Telstra Plus members can get 40,000 Telstra Plus bonus points for switching to Huddle Comprehensive Car insurance<sup>1</sup>.',
        image: 'https://media.beopen.com/huddle/huddle-rewards.webp',
        buttons: [
          {
            link: 'cmp-hdl-car',
            label: 'Get a quote'
          }
        ]
      }
    },
    {
      type: 'product-features',
      settings: {
        heading: 'Everything you get with Huddle',
        subtext: '',
        cards: [
          {
            icon: 'huddle-housing-management-24x7claimsprocessing',
            content: 'Buy, manage and claim online, anytime'
          },
          {
            icon: 'huddle-housing-marketing-environmental',
            content: 'Complimentary carbon offset with your new Car or Home policy<sup>5</sup>'
          },
          {
            icon: 'huddle-housing-marketing-liablity',
            content: 'Pay monthly, or save by paying annually on Car or Home Insurance'
          },
          {
            icon: 'huddle-housing-marketing-localsupport',
            content: 'Local insurance experts, book online and we\'ll call when it suits you'
          },
          {
            icon: 'huddle-housing-marketing-flexibleaccess',
            content: 'Flex your excess to reduce your premium'
          },
          {
            icon: 'huddle-housing-marketing-optionals',
            content: 'Customisable cover with optional handy extras'
          },
          {
            icon: 'huddle-housing-management-24/7claimsprocessing',
            content: '24/7 emergency assistance'
          },
          {
            icon: 'huddle-housing-management-fastclaims',
            content: 'Fast claims - some car insurance claims get a decision in minutes'
          }
        ]
      }
    },
    {
      type: 'product-accordion',
      settings: {
        heading: 'Commonly asked questions',
        accordionItems: [
          {
            title: 'How many bonus points will I get?',
            content: `
            The amount of bonus points you’ll get for buying eligible car or home insurance with Huddle depends on your policy.<br><br>
            Get 500 points with your first online quote for an eligible home or car insurance policy1. A quote is complete upon reaching the payment page with the final, confirmed price. Travel quotes do not qualify for the bonus points promotion.<br><br>
            Get 5,000 bonus points on the following Huddle policies. This only applies if the policy hasn't been purchased within 90 days of a previous policy ending that covered the same risk, such as the same destination and travel dates:<br>
            Huddle Travel Insurance – International Essentials<br>
            Huddle Travel Insurance – International Standard<br>
            Huddle Travel Insurance – International Comprehensive<br>
            Huddle Travel Insurance – Domestic Comprehensive<br><br>
            
            Get 15,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
            Huddle Car Insurance – Third Party Property<br>
            Huddle Home Insurance – Home only<br>
            Huddle Home Insurance – Contents only<br><br>
            
            Get 40,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
            Huddle Comprehensive Car Insurance<br>
            Huddle Combined Home & Contents Insurance
            `
          },
          {
            title: 'How does Pay As You Drive Cover work?',
            content: `
            Pay As You Drive Cover is comprehensive insurance for drivers who spend less time behind the wheel.

When you sign up, you can buy between 1,000km to 15,000km per year, depending on how many kilometres you think you'll drive during the period of insurance.<br><br>
            We'll then ask you for your start odometer reading within 14 days of the start date of your policy. Your end odometer reading will be your start odometer reading plus the number of kilometres you purchased.<br><br>
            Your Certificate of Insurance will show:
            <ul>
              <li>the start odometer reading you gave us;</li>
              <li>the number of kilometres you purchased; and</li>
              <li>your end odometer reading</li>
            </ul>
            Don't worry, if you think you'll drive more than the number of kilometres that you purchased, you can top up your kilometres during the term through the ‘Manage policies’ section of your account. Just keep in mind that we'll need to adjust your premium, too. Check out our PDS for more details.<br><br>
            If you need to make a claim and your odometer reading at the time of the claim is less than your start odometer reading or greater than your end odometer reading, a $1,000 additional excess will apply.<br><br>
            Make sure you give us your start odometer reading within 14 days of the start date of your policy. If you need to make a claim after this time and you have not given us your start odometer reading, the $1,000 additional excess will apply.
            `
          },
          {
            title: 'What is Huddle Black?',
            content: `
              Huddle Black is our most powerful level of comprehensive car insurance cover. You get all the benefits of our Comprehensive Car Insurance cover plus additional benefits, higher limits and even roadside assistance.<br><br>
              For more details, see our Product Disclosure Statement. Roadside assistance terms of service apply.
            `
          },
          {
            title: 'Can I choose where to get my car repaired?',
            content: `
            If we accept your claim and the damage to your car can be repaired, we’ll arrange for your car to be repaired using trusted car repairers. We work closely with trusted car repairers to make sure they provide you with quality repairs in a timely manner.<br><br>
            With Huddle Black you can choose your own repairer, but we may still ask you to get a quote from a repairer we select, too.<br><br>
            Click here to view our car repairer network across Australia.
            `
          },
          {
            title: 'Is anyone insured to drive my car?',
            content: `
              We insure licensed drivers as well as learner drivers, as long as they’re older than the minimum age listed on your Certificate of Insurance and are following the requirements of their learner’s licence.<br><br>
              Internationally licenced drivers are also insured, as long as the road traffic authority in the Australian state or territory that they drive the car in recognises their international licence and the driver complies with their licence conditions.
            `
          },
          {
            title: 'Can I choose my excess?',
            content: `
              You can choose an excess from $500 to $5,000. Just make sure you keep in mind what you can afford to pay in the event you need to claim.
            `
          },
          {
            title: 'How can I get the lowest premium?',
            content: `
            There are many factors that contribute to setting your premium, and a safe driving history will go a long way. But choosing the Pay As You Drive cover or a higher excess that you can afford may also help reduce the premium you'll pay. Simply get a quote and choose the options that are best for you. Pay As You Drive is only available for our Comprehensive and Huddle Black cover levels.
            `
          }
        ]
      }
    },
    {
      type: 'product-text-block',
      settings: {
        content: `<p class="small text-darkGray">
        <strong>1. Telstra Plus bonus points offer terms</strong><br>
        Offer ends 30 June 2026 unless extended or withdrawn earlier. Sign up with your Telstra ID to get started. Offer subject to eligibility criteria and other terms and conditions. Must start journey from Telstra Plus website. See the Commonly Asked Questions section, and read the Telstra Plus terms and conditions and the offer terms and conditions.  Offer permits multiple eligible policy purchases. A new policy is eligible for this offer only if it is not purchased within 90 days following the end of a previous policy that covered the same risk, such as destination and travel dates. Points awarded after a car or home policy has been active for 30 days, for a travel policy, points are awarded 30 days after it’s purchased, and it hasn’t been cancelled. They will then be added to your points activity within an additional 14 days.<br>
        Policies are subject to terms and conditions, exclusions, and limits (and sub-limits) of the insurance policy. When making decisions about the product, you should always refer to the Product Disclosure Statement.You can also read the relevant Target Market Determination (TMD) which explains who Huddle’s insurance products are suitable for. Must start journey from Telstra Plus website. Read the Telstra Financial Services Guide.<br><br>
        <strong>2. How our Pay As You Drive discount works‍</strong><br>
        Saving of up to 30% derived from premium comparisons between Huddle unlimited kilometre comprehensive car cover option and Huddle Pay As You Drive comprehensive car cover option. Calculations based on a sample of profiles of existing Huddle car insurance customers who advised they drive under 15,000 km annually. Current as at 9 May 2024. Actual savings are determined by your individual circumstances, including the kilometres selected, excess chosen and other risk factors. Minimum premiums may reduce savings. Kilometres can be increased during the policy period, an additional premium is payable. In the event of an accident and the end odometer reading is exceeded or is below the start odometer reading on your Certificate of Insurance, an additional excess is applied.<br><br>
        <strong>3. Carbon offset‍</strong><br>
        We’ll pay to help offset your carbon emissions by planting and protecting native forests when you buy a new policy. We do this by partnering with Greenfleet. They plant biodiverse, native forests in Australia and New Zealand, which are legally protected for 100 years. New policies from 29 November 2022. Not applicable to policy renewal.<br><br>
        Our car and home insurance is issued by Huddle Insurance, a business name of Open Insurance Pty Ltd, ABN 23 166 949 444, AFSL no. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL no. 241436. Open acts as an agent of Hollard and not on your behalf. Any information provided on this site is general information only and does not take into account your individual needs, objectives or financial situation. You should carefully read the relevant Product Disclosure Statement and Financial Services Guide, and consider the relevant Target Market Determination to help you decide if the product is right for you. Eligibility criteria apply.<br><br>
        Telstra Limited (ABN 64 068 174 781, AR No. 1303090) is an authorised representative of Open Insurance Pty Ltd (ABN 23 166 949 444, AFSL No. 451712) (Open).<br><br>
        Insurance issued by Huddle Insurance, a business name of Open Insurance Pty Ltd ABN 23 166 949, 444 AFSL No. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL No. 241436. Any information or advice provided on this site is general only and doesn't take into account your individual needs, objectives or financial situation. Benefits are subject to terms and conditions, including exclusions and limits of the insurance policy. Please carefully read the relevant Product Disclosure Statement (PDS) and Financial Services Guide and consider the relevant Target Market Determination (TMD) to decide if the product is right for you.
      </p>`
      }
    }
  ]
};

export const telstra_home = {
  components: [
    {
      type: 'product-hero-banner',
      settings: {
        capsule: 'Exclusive to Telstra Plus members',
        heading: 'Insure your home & contents and get Telstra Plus points',
        content: 'Telstra Plus members can earn up to 40,500 bonus points with new Huddle Home and Contents insurance<sup>1</sup>.',
        image: 'https://media.beopen.com/huddle/huddle-home-hero.webp',
        brandIcon: 'https://media.beopen.com/telstra/logo-telstra-white.svg',
        buttons: [
          {
            link: 'hud-compare-home',
            label: 'Get a quote in minutes'
          }
        ],
        showTrustpilot: true
      }
    },
    {
      type: 'product-trustpilot',
      settings: {
        heading: 'Trusted by thousands of Australians, 100,000+ policies sold',
        reviews: [
          {
            rating: 5,
            title: 'Treated wonderfully',
            content: '"Had to phone to make a claim and was greeted and treated wonderfully. Thank you to Lewis :)"',
            author: 'Melanie F'
          },
          {
            rating: 5,
            title: 'Quick quotes and sign up',
            content: '"Huddle made it easy to insure my car with the whole process done on my phone\'s web browser in 15 minutes while I was at the dealership."',
            author: 'Michelle C'
          },
          {
            rating: 5,
            title: 'Very easy',
            content: '"Very easy online process to manage your policies, especially pay as you go mileage. Also very reasonable premium."',
            author: 'Michael K'
          }
        ]
      }
    },
    {
      type: 'product-callout',
      settings: {
        heading: 'Earn up to 40,500 Telstra Plus points<sup>1</sup>',
        content: 'See the Commonly Asked Questions below, and read the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a>.'
      }
    },
    {
      type: 'product-cross-content',
      settings: {
        heading: 'Save 10% by combining home & contents insurance<sup>2</sup>',
        content: `
          Combining home and contents means that your belongings, house and its permanent fixtures are protected under your selected cover choice.<br><br>
          If the unexpected happens we can help replace things like your furniture and home appliances and cameras, as well as repair or rebuild your home.
        `,
        image: 'https://media.beopen.com/huddle/huddle-home-contents.webp',
        buttons: [
          {
            link: '',
            label: 'Get a quote'
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Home insurance made easy',
        cards: [
          {
            image: 'huddle-valuables-electronics',
            title: 'Online, anytime',
            content: 'You’re in control - buy, manage and make claims online. It’s how insurance should be.'
          },
          {
            image: 'huddle-outlined-management-fastclaims',
            title: 'Back on your feet, faster',
            content: 'Submit a claim online 24/7. Our clever tech and expert claims team will get the ball rolling so you get the help you need.'
          },
          {
            image: 'huddle-outlined-marketing-localsupport',
            title: 'Skip waiting on hold',
            content: 'Have questions about your quote, policy or claim? Book online and we’ll call when it suits you.'
          }
        ]
      }
    },
    {
      type: 'product-features',
      settings: {
        heading: 'Cover for when life doesn’t go to plan',
        subtext: 'We cover loss or damage to your home and contents, for these events and more. ',
        cards: [
          {
            icon: 'huddle-housing-management-24x7claimsprocessing',
            content: 'Fire and bushfire'
          },
          {
            icon: 'huddle-housing-marketing-environmental',
            content: 'Flood, storm and rainwater'
          },
          {
            icon: 'huddle-housing-marketing-liablity',
            content: 'Earthquake, tsunami, or volcanic eruption'
          },
          {
            icon: 'huddle-housing-marketing-localsupport',
            content: 'Theft and malicious damage '
          },
          {
            icon: 'huddle-housing-marketing-flexibleaccess',
            content: 'Accidental glass breakage'
          },
          {
            icon: 'huddle-housing-marketing-optionals',
            content: 'Escape of liquid, like when a pipe bursts unexpectedly'
          }
        ],
        terms: 'Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination</a> which explains who the products are suitable for'
      }
    },
    {
      type: 'product-features-table',
      settings: {
        heading: 'Choose your level of home & contents cover ',
        subtext: 'Summary only. Full benefits, terms and conditions are in our <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a>.',
        tableData: [
          {
            tabLabel: 'Home insurance',
            table: [
              [
                {},
                {
                  label: 'Basic'
                },
                {
                  label: 'Comprehensive'
                },
                {
                  label: 'Huddle Black Comprehensive'
                }
              ],
              [
                {
                  label: `Emergency accommodation<br>
                  <span class="font-normal">If your home isn't safe to live in due to an insured event, we'll pay for temporary accommodation while it is repaired or rebuilt.</span>`
                },
                {
                  label: 'The lesser of 12 months’ rent or 10% of your home sum insured.',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'The lesser of 12 months’ rent or 10% of your home sum insured.',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to 20% of your home sum insured',
                  icon: 'check_circle_outline'
                }
              ],
              [
                {
                  label: `Environmental benefits<br>
                  <span class="font-normal">If your home needs to be rebuilt due to an insured event, we'll pay to install environmental improvements such as solar panels and rainwater tanks.</span>`
                },
                {
                  label: 'Up to $2,500',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Emergency pet accommodation<br>
                  <span class="font-normal">If we're putting you up in emergency accommodation, we’ll help pay for temporary accommodation for your dogs and cats.</span>`
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: 'Up to $1,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Emergency storage<br>
                  <span class="font-normal">We'll pay to move and store your contents while your home is being repaired or rebuilt due to an insured event.</span>`
                },
                {
                  label: 'Up to 10% of your contents sum insured',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to 15% of your contents sum insured',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to 15% of your contents sum insured',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Replacement locks<br>
                  <span class="font-normal">If a claim for theft is covered under the policy and, as part of that theft, the keys to external doors are stolen, we’ll pay the cost of replacing those locks.</span>`
                },
                {
                  label: 'Up to $750',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $1,500',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $2,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Damage to landscaping<br>
                  <span class="font-normal">We’ll pay to replace landscaping features like trees, plants or shrubs, fountains, and ponds, which are stolen, burnt, maliciously damaged or damaged by a vehicle.</span>`
                },
                {
                  label: 'Up to $750',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $1,500',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Electrical motor burnout<br>
                  <span class="font-normal">We’ll cover the cost of repairing or replacing any burnt out motor which forms part of your home, like in a garage door or swimming pool pump.</span>`
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: 'Up to $2,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Legal liability<br>
                  <span class="font-normal">We provide cover for claims made against you for death or injury to another person and loss or damage to someone else’s property.</span>`
                },
                {
                  label: 'Up to $20 million',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $20 million',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to $30 million',
                  icon: 'check_circle'
                }
              ]
            ]
          },

          {
            tabLabel: 'Contents insurance',
            table: [
              [
                {},
                {
                  label: 'Basic'
                },
                {
                  label: 'Comprehensive'
                },
                {
                  label: 'Huddle Black Comprehensive'
                }
              ],
              [
                {
                  label: `Contents in your home office<br>
                  <span class="font-normal">Cover for contents in your home office caused by an insured event.</span>`
                },
                {
                  label: 'Up to $2,500',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $10,000',
                  icon: 'check_circle_outline'
                }
              ],
              [
                {
                  label: `Contents in your new and old address<br>
                  <span class="font-normal">Cover for your contents in the home at both your new and old addresses for up to 14 days from the day you start moving.</span>`
                },
                {
                  label: 'Up to your contents sum insured',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to your contents sum insured',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to your contents sum insured',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Portable Valuables cover (optional)<br>
                  <span class="font-normal">Optional cover for your specified items anywhere in Australia (and New Zealand with Huddle Black). Cover limits apply. Excludes mobile phones.</span>`
                },
                {
                  label: '<span class="font-bold">Optional</span><br><br>Covers anywhere in Australia',
                  icon: ''
                },
                {
                  label: '<span class="font-bold">Optional</span><br><br>Covers anywhere in Australia',
                  icon: ''
                },
                {
                  label: '<span class="font-bold">Optional</span><br><br>Covers anywhere in Australia and New Zealand',
                  icon: ''
                }
              ],
              [
                {
                  label: `Legal liability<br>
                  <span class="font-normal">We provide cover for claims made against you for death or injury to another person and for loss or damage to someone else’s property.</span>`
                },
                {
                  label: 'Up to $20 million',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $20 million',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to $30 million',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Credit cards<br>
                  <span class="font-normal">If your card is lost or stolen from your home, we’ll pay for loss or theft of your funds if your card is used fraudulently.</span>`
                },
                {
                  label: 'Up to $2,500',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Contents while in transit<br>
                  <span class="font-normal">Cover for your contents while they’re being moved from your old address to your new address for loss or damage caused by fire, collision or overturning of the vehicle carrying them.</span>`
                },
                {
                  label: 'Up to 20% of your contents sum insured',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to your contents sum insured',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to your contents sum insured',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Food spoilage<br>
                  <span class="font-normal">We'll cover food spoilage in your fridge or freezer caused by a failure of public electricity supply to your home.</span>`
                },
                {
                  label: 'Up to $500',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $1,000',
                  icon: 'check_circle'
                },
                {
                  label: 'Up to $2,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Visitor contents<br>
                  <span class="font-normal">We'll cover loss or damage to your visitors' stuff caused by an insured event at your home.</span>`
                },
                {
                  label: 'Up to $2,500',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Up to $5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: `Electrical motor burnout<br>
                  <span class="font-normal">We’ll pay the cost of repairing or replacing any burnt out motor which forms part of your contents like in a food processor.</span>`
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: '',
                  icon: 'clear'
                },
                {
                  label: 'Up to $2,000',
                  icon: 'check_circle'
                }
              ]
            ]
          }
        ],
        terms: `
          <p class="text-xsmall">Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination</a> which explains who the products are suitable for.</p>
        `
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'dark',
        columns: 3,
        type: 'simple-icon',
        heading: 'Huddle Black, our most powerful insurance yet ',
        subtext: '<p>Enjoy all the benefits of our Comprehensive cover, plus: </p>',
        cards: [
          {
            image: 'huddle-marketing-liability',
            title: 'Boosted limits, exclusive benefits',
            content: 'Get higher limits and a wider range of perks, including up to $10,000 for home office contents, and up to $2,000 for loss or damage to your tools of trade while at your home.'
          },
          {
            image: 'huddle-valuables-electronics',
            title: 'Cover valuables across Australia and New Zealand (Optional)',
            content: 'You can add Portable Valuables Cover for things you take out and about, like your handbag, jewellery, laptop or tablet. Cover limits apply. Excludes mobile phones.'
          },
          {
            image: 'huddle-outlined-marketing-petaccomodation',
            title: 'Emergency pet accommodation',
            content: 'If we\'re putting you up in emergency accommodation, we’ll also pay up to $1,000 for temporary accommodation for your dogs and cats.'
          },
          {
            image: 'huddle-outlined-marketing-homeassist',
            title: '24/7 call-outs with Huddle Home Assist',
            content: 'Locked out? Burst tap? Get 24/7 assistance from plumbers, electricians and locksmiths, for 10 common home emergencies. See Huddle Home Assist terms.'
          }
        ],
        buttons: [
          {
            link: '',
            label: 'Get a quote'
          }
        ],
        disclaimer: 'Huddle insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination</a> which explains who the products are suitable for.'
      }
    },
    {
      type: 'product-banner',
      settings: {
        heading: 'Get rewarded with Telstra Plus',
        content: 'Telstra Plus members can get 40,000 Telstra Plus bonus points for switching to Huddle Comprehensive Car insurance<sup>1</sup>.',
        image: 'https://media.beopen.com/huddle/huddle-rewards.webp',
        buttons: [
          {
            link: 'hud-compare-home',
            label: 'Get a quote'
          }
        ]
      }
    },
    {
      type: 'product-features',
      settings: {
        heading: 'Everything you get with Huddle',
        subtext: '',
        cards: [
          {
            icon: 'huddle-housing-management-24x7claimsprocessing',
            content: 'Buy, manage and claim online, anytime'
          },
          {
            icon: 'huddle-housing-marketing-environmental',
            content: 'Complimentary carbon offset with your new policy<sup>3</sup>'
          },
          {
            icon: 'huddle-housing-marketing-liablity',
            content: 'Pay monthly or save by paying annually'
          },
          {
            icon: 'huddle-housing-marketing-localsupport',
            content: 'Local insurance experts, book online and we\'ll call when it suits you'
          },
          {
            icon: 'huddle-housing-marketing-flexibleaccess',
            content: 'Flex your excess to reduce your premium'
          },
          {
            icon: 'huddle-housing-marketing-optionals',
            content: 'Customisable cover with optional handy extras'
          },
          {
            icon: 'huddle-housing-management-24/7claimsprocessing',
            content: '24/7 emergency assistance'
          },
          {
            icon: 'huddle-housing-management-fastclaims',
            content: 'Fast claims - some car insurance claims get a decision in minutes'
          }
        ]
      }
    },
    {
      type: 'product-accordion',
      settings: {
        heading: 'Commonly asked questions',
        accordionItems: [
          {
            title: 'How many bonus points will I get?',
            content: `
              The amount of bonus points you’ll get for buying eligible car or home insurance with Huddle depends on your policy.<br><br>
              Get 500 points with your first online quote for an eligible home or car insurance policy1. A quote is complete upon reaching the payment page with the final, confirmed price. Travel quotes do not qualify for the bonus points promotion.<br><br>
              Get 5,000 bonus points on the following Huddle policies. This only applies if the policy hasn't been purchased within 90 days of a previous policy ending that covered the same risk, such as the same destination and travel dates:<br>
              Huddle Travel Insurance - International Essentials<br>
              Huddle Travel Insurance - International Standard<br>
              Huddle Travel Insurance - International Comprehensive<br>
              Huddle Travel Insurance - Domestic Comprehensive<br><br>

              Get 15,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
              Huddle Car Insurance - Third Party Property<br>
              Huddle Home Insurance - Home only<br>
              Huddle Home Insurance - Contents only<br><br>

              Get 40,000 bonus points on the following Huddle policies if you stay insured for 30 days:<br>
              Huddle Comprehensive Car Insurance<br>
              Huddle Combined Home & Contents Insurance
            `
          },
          {
            title: 'What are the different types of home insurance I can get with Huddle?',
            content: `<ul>
            <li>Home insurance</li>
            <li>Contents insurance</li>
            <li>Home and contents insurance</li>
            </ul>
            `
          },
          {
            title: 'What does accidental damage mean?',
            content: `
              Accidental damage means damage caused unintentionally to your home, if you have Home Insurance with this cover option, or contents, if you have Contents Insurance with this cover option. Accidental damage can cover things like your favourite vase breaking or your hallway wall being damaged as you’re moving your new couch in.<br><br>
              You will be covered for accidental damage if you choose the Comprehensive Cover option or Huddle Black for your policy.<br><br>
              Some things are excluded, like scratching, chipping or denting, caused by normal use. See the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a> for more information.<br><br>
              Under the Basic Cover option, you will still be covered for accidental glass breakage. Policy terms do apply.
            `
          },
          {
            title: 'Can I pay my premium monthly?',
            content: `
              Yes. You can choose to pay monthly for your home insurance, or save by paying annually.
            `
          },
          {
            title: 'I’m going on holiday, what do I need to do?',
            content: `
              It's important to let us know if your home will be unoccupied for a period of more than 100 consecutive days. If you tell us, we may be able to provide cover during this period subject to certain conditions for your home being unoccupied. See the section titled ‘Leaving your home unoccupied’ in the Huddle Home & Contents Insurance <a href="https://huddle.com.au/pds" target="_blank" color="primary">Product Disclosure Statement</a> for details.<br><br>
We do not provide cover where your whole home is rented out on Airbnb or similar shorter term rental (even if it's just while you're on holiday).
              `
          },
          {
            title: 'What’s the difference between Home Insurance and Contents Insurance?',
            content: `
              Home Insurance is for homeowners who live in their home and want insurance for their building and fixtures. It covers the residential buildings, domestic outbuildings, fixtures, services like electricity, water and gas at the insured site, permanently installed swimming pools and paved driveways etc.<br><br>
Contents Insurance is for homeowners living in their home or renters renting a home who want insurance for their things. Contents include things like art, watches, jewellery, sporting equipment, carpets, rugs, furniture, electronics, bicycles, portable musical instruments and more.
            `
          },
          {
            title: 'I’m a landlord, can I use this policy?',
            content: `
            No, our policies are not designed for landlords.<br><br>
            <ul>
            <li>Huddle Home Insurance is designed for owner-occupiers who want insurance for their home.</li>
            <li>Huddle Contents Insurance is designed for homeowners, owners of strata-titled residential properties or renters, who want insurance for their contents.</li>
            <li>Huddle Home & Contents Insurance is designed for owner-occupiers who want insurance for both their home and contents.</li>
            </ul>
            `
          },
          {
            title: 'Some of my belongings are very valuable. How are they covered?',
            content: `
            Your valuable contents are covered up to your contents sum insured while inside your home, however some types of contents have fixed or flexible limits.<br><br>
            For example, the maximum we can provide cover up to for bicycles or portable musical instruments is $1,000 per item for Basic Cover or $2,000 per item for Comprehensive Cover.<br><br>
            Jewellery, watches, collectables, and media (like CDs and DVDs) are covered up to flexible limits depending on your cover level, but you can increase these limits by letting us know and having the items individually listed with their value on your Certificate of Insurance. You don't pay extra for this, for cover within your home, so long as you account for these valuables when choosing how much to insure your contents for.<br><br>
            You can also add our Portable Valuables Cover option to cover things you take on the go. Check out the relevant Product Disclosure Statement for more information on Portable Valuables Cover.<br><br>
            For more information on the limits that apply to contents and valuables, you can check out the relevant Product Disclosure Statement.
            `
          },
          {
            title: 'Am I covered for flood?',
            content: `
            Yes, you’re covered for flood whether you choose Home Insurance, Contents Insurance or both. The higher of your chosen basic excess or a fixed excess of $500 applies (as defined in the Product Disclosure Statement) to each flood event.<br><br>
            There's no cover for rainwater or flood, if it occurs within the first 72 hours of the time you first purchase the policy, or you subsequently purchase the policy after any gap in home/ contents cover, unless you transferred a home/ contents insurance policy with equivalent cover to us from another insurance company without an interruption in cover. We will not cover any increase in sums insured for these events in the first 72 hours. <br><br>
            Terms, conditions and exclusions apply, so please read the <a href="https://huddle.com.au/pds" target="_blank" color="primary">Product Disclosure Statement</a> for details.
            `
          }
        ]
      }
    },
    {
      type: 'product-text-block',
      settings: {
        content: `<p class="small text-darkGray">
        <strong>1. Telstra Plus bonus points offer terms</strong><br>
        Offer ends 30 June 2026 unless extended or withdrawn earlier. Sign up with your Telstra ID to get started. Offer subject to eligibility criteria and <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">other terms and conditions</a>. Must start journey from Telstra Plus website. See the Commonly Asked Questions section, and read the <a href="https://www.telstra.com.au/plus/terms-and-conditions" target="_blank">Telstra Plus terms and conditions</a> and the <a href="https://www.telstra.com.au/plus/huddle-terms" target="_blank">offer terms and conditions</a>.  Offer permits multiple eligible policy purchases. A new policy is eligible for this offer only if it is not purchased within 90 days following the end of a previous policy that covered the same risk, such as destination and travel dates. Points awarded after a car or home policy has been active for 30 days, for a travel policy, points are awarded 30 days after it’s purchased, and it hasn’t been cancelled. They will then be added to your points activity within an additional 14 days.<br>
        Policies are subject to terms and conditions, exclusions, and limits (and sub-limits) of the insurance policy. When making decisions about the product, you should always refer to the <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement</a>. You can also read the relevant <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination (TMD)</a> which explains who Huddle’s insurance products are suitable for. Must start journey from Telstra Plus website. <a href="https://www.telstra.com.au/plus/financialservicesguide" target="_blank">Read the Telstra Financial Services Guide</a>.<br><br>
        
        <strong>2. How our combined Home & Contents discount works</strong><br>
        Receive a 10% discount when you purchase a combined Home and Contents policy, which applies for the life of your combined policy. Minimum premiums may reduce savings discount. We reserve the right to withdraw or extend this discount at any time.<br><br>
        
        <strong>3. Carbon offset‍</strong><br>
        We’ll pay to help offset your carbon emissions by planting and protecting native forests when you buy a new policy. We do this by partnering with Greenfleet. They plant biodiverse, native forests in Australia and New Zealand, which are legally protected for 100 years. New policies from 29 November 2022. Not applicable to policy renewal.<br><br>
        Our car and home insurance is issued by Huddle Insurance, a business name of Open Insurance Pty Ltd, ABN 23 166 949 444, AFSL no. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL no. 241436. Open acts as an agent of Hollard and not on your behalf. Any information provided on this site is general information only and does not take into account your individual needs, objectives or financial situation. You should carefully read the relevant Product Disclosure Statement and Financial Services Guide, and consider the relevant Target Market Determination to help you decide if the product is right for you. Eligibility criteria apply.<br><br>
        Telstra Limited, ABN 64 086 174 781, AR 1303090, is a promoter of Huddle insurance and is arranging the insurance as an authorised representative of Open Insurance Pty Ltd, ABN 23 166 949 444, AFSL no. 451712. Read the Telstra Financial Services Guide.<br><br>
        Insurance issued by Huddle Insurance, a business name of Open Insurance Pty Ltd ABN 23 166 949, 444 AFSL No. 451712 on behalf of the insurer, The Hollard Insurance Company Pty Ltd, ABN 78 090 584 473, AFSL No. 241436. Any information or advice provided on this site is general only and doesn't take into account your individual needs, objectives or financial situation. Benefits are subject to terms and conditions, including exclusions and limits of the insurance policy. Please carefully read the relevant Product Disclosure Statement (PDS) and Financial Services Guide and consider the relevant Target Market Determination (TMD) to decide if the product is right for you.
      </p>`
      }
    }
  ]
};
